import { formatEther } from "@ethersproject/units";
import { useMemo } from "react";
import { useReadContracts } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";

const useSbUsdExchangeRate = () => {
  const { stableVaultConfig } = useDappConfig();
  const { chain } = useDappChain();

  const exchangeRateContracts = useMemo(() => {
    if (!stableVaultConfig) return [];

    const contracts = [];
    const vaultConfig = stableVaultConfig?.interactionPool;

    //Deposit
    contracts.push({
      ...vaultConfig,
      functionName: "convertToShares",
      args: [1000000000000000000],
      chainId: chain.id,
    });

    //Withdraw
    contracts.push({
      ...vaultConfig,
      functionName: "convertToAssets",
      args: [1000000000000000000],
      chainId: chain.id,
    });

    return contracts;
  }, [stableVaultConfig, chain.id]);

  const { data, isLoading } = useReadContracts({
    contracts: exchangeRateContracts,
    query: {
      refetchInterval: 90_000,
    },
  });

  /*
    toShare -> Deposit (fromERC20)
    toAsset -> Withdraw (toERC20)
 */
  const exchangeData = useMemo(() => {
    if (data) {
      return {
        fromERC20: data[0]?.result && formatEther(data[0]?.result as bigint),
        toERC20: data[1]?.result && formatEther(data[1]?.result as bigint),
        isLoading,
      };
    }
    return { fromERC20: 0, toERC20: 0, isLoading };
  }, [data, isLoading]);

  return exchangeData;
};

export default useSbUsdExchangeRate;
